//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const URL = import.meta.env.VITE_DRIVER_SCORE_API || `${window.location.origin}/scores`;

export class TelematicsDriverScoreClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Retrieves the driver's average scores across all trips during their policy period.
	 * @param policyReference (optional) The unique policy reference number (e.g., HAVPC00000001). Must belong to the authenticated customer.
	 * @return Successfully retrieved the driver's average scores.
	 */
	average(policyReference: string | undefined, cancelToken?: CancelToken): Promise<DriverAverageScoresDto> {
		let url_ = this.baseUrl + '/api/v1/Scores/average?';
		if (policyReference === null) throw new globalThis.Error("The parameter 'policyReference' cannot be null.");
		else if (policyReference !== undefined) url_ += 'policyReference=' + encodeURIComponent('' + policyReference) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processAverage(_response);
			});
	}

	protected processAverage(response: AxiosResponse): Promise<DriverAverageScoresDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<DriverAverageScoresDto>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'The policy reference is missing, empty, or in an invalid format.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException(
				'The policy was not found or does not belong to the authenticated customer.',
				status,
				_responseText,
				_headers,
				result404,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<DriverAverageScoresDto>(null as any);
	}

	/**
	 * Retrieves personalised driving insights including score trends and actionable improvement tips.
	 * @param policyReference (optional) The unique policy reference number (e.g., HAVPC00000001). Must belong to the authenticated customer.
	 * @param periodDays (optional) The comparison period in days. Valid values: 7, 14, or 30. Defaults to 7.
	 * @return Successfully retrieved the driver's score insights and recommendations.
	 */
	insights(
		policyReference: string | undefined,
		periodDays: number | undefined,
		cancelToken?: CancelToken,
	): Promise<DriverScoreInsightsDto> {
		let url_ = this.baseUrl + '/api/v1/Scores/insights?';
		if (policyReference === null) throw new globalThis.Error("The parameter 'policyReference' cannot be null.");
		else if (policyReference !== undefined) url_ += 'policyReference=' + encodeURIComponent('' + policyReference) + '&';
		if (periodDays === null) throw new globalThis.Error("The parameter 'periodDays' cannot be null.");
		else if (periodDays !== undefined) url_ += 'periodDays=' + encodeURIComponent('' + periodDays) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processInsights(_response);
			});
	}

	protected processInsights(response: AxiosResponse): Promise<DriverScoreInsightsDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<DriverScoreInsightsDto>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'The policy reference is invalid or periodDays is not 7, 14, or 30.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException(
				'The policy was not found or does not belong to the authenticated customer.',
				status,
				_responseText,
				_headers,
				result404,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<DriverScoreInsightsDto>(null as any);
	}
}

/** DTO containing current period score averages. */
export interface CurrentAveragesDto {
	/** Average speed score. */
	speedScoreAvg?: number | undefined;
	/** Average smooth score. */
	smoothScoreAvg?: number | undefined;
	/** Average use score. */
	useScoreAvg?: number | undefined;
	/** Average total score. */
	totalScoreAvg?: number | undefined;
}

/** DTO representing the driver's average scores over their policy period. */
export interface DriverAverageScoresDto {
	/** The policy reference. */
	policyReference?: string | undefined;
	/** The start of the policy period (UTC). */
	policyPeriodStartUtc?: Date;
	/** The end of the policy period (UTC). */
	policyPeriodEndUtc?: Date;
	averages?: ScoreAveragesDto;
	/** The number of trips used in the average calculation. */
	tripCountUsed?: number;
}

/** DTO representing driver score insights including trends and tips. */
export interface DriverScoreInsightsDto {
	/** The policy reference. */
	policyReference?: string | undefined;
	/** The comparison period in days. */
	periodDays?: number;
	/** Human-readable headline summarizing the trend. */
	headline?: string | undefined;
	trends?: ScoreTrendsDto;
	currentAverages?: CurrentAveragesDto;
	/** The weakest scoring area (speed, smoothness, usage). */
	weakestArea?: string | undefined;
	/** Personalized tips to improve scores. */
	tips?: TipDto[] | undefined;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

/** DTO containing the individual score averages. All scores are transformed from the original [-10, 10] range to a user-friendly [0, 100] range. */
export interface ScoreAveragesDto {
	/** Average speed score. NULL if no trips have speed scores.
Range: 0 to 100 (higher is better). */
	speedScoreAvg?: number | undefined;
	/** Average smooth score. NULL if no trips have smooth scores.
Range: 0 to 100 (higher is better). */
	smoothScoreAvg?: number | undefined;
	/** Average use score. NULL if no trips have use scores.
Range: 0 to 100 (higher is better). */
	useScoreAvg?: number | undefined;
	/** Average total score. NULL if no trips have total scores.
Range: 0 to 100 (higher is better). */
	totalScoreAvg?: number | undefined;
}

/** DTO containing score trend information. */
export interface ScoreTrendsDto {
	/** Overall score percentage change. */
	overallChange?: number | undefined;
	/** Overall trend direction (improving, declining, stable, unknown). */
	overallTrend?: string | undefined;
	/** Speed score percentage change. */
	speedScoreChange?: number | undefined;
	/** Smooth score percentage change. */
	smoothScoreChange?: number | undefined;
	/** Use score percentage change. */
	useScoreChange?: number | undefined;
	/** Number of trips in the current period. */
	currentPeriodTripCount?: number;
	/** Number of trips in the previous period. */
	previousPeriodTripCount?: number;
}

/** DTO representing a personalized driving tip. */
export interface TipDto {
	/** Category (speed, smoothness, usage). */
	category?: string | undefined;
	/** Priority (1 = highest). */
	priority?: number;
	/** Short title. */
	title?: string | undefined;
	/** Detailed description. */
	description?: string | undefined;
	/** Potential impact (high, medium, low). */
	potentialImpact?: string | undefined;
}

export interface ValidationProblemDetails {
	errors?: any | undefined;
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export class ApiException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isApiException = true;

	static isApiException(obj: any): obj is ApiException {
		return obj.isApiException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
